import Wrapper from './QuickActionMenu';
export default Wrapper;
